module.exports = __webpack_public_path__ + "media/src/images/top_covers/3sky-b6cf525ac1133791675eecf4c8ba84e5.png";